import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getActivitiesRequest } from "lib/api/reference/activity";
import type { ActivityInterface } from "types/reference";

export const activityReferenceKeys = {
    all: ["reference", "activity"] as const,
    list: (languageCode: string) => [...activityReferenceKeys.all, "list", languageCode] as const,
};

export const fetchActivities = (languageCode: string) =>
    parseResponse<Array<ActivityInterface>>(getActivitiesRequest(languageCode));

export const activityReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<ActivityInterface>>({
        queryKey: activityReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchActivities(languageCode),
        enabled: Boolean(languageCode),
    });

export const useActivities = (languageCode: string) => useQuery(activityReferenceQueryOptions(languageCode));
